type ScaleX = number
type ScaleY = number
type TranslateX = number
type TranslateY = number
type Unused = number

// prettier-ignore
export type Mat2D = [
    ScaleX, Unused,
    Unused, ScaleY,
    TranslateX, TranslateY,
]

type Vector = [x: number, y: number]

export function create(): Mat2D {
    const out = new Float32Array(6) as unknown as Mat2D

    out[0] = 1
    out[3] = 1

    return out
}

export function identity(out: Mat2D): Mat2D {
    out[0] = 1
    out[1] = 0
    out[2] = 0
    out[3] = 1
    out[4] = 0
    out[5] = 0

    return out
}

export function clone(out: Mat2D, a: Mat2D): Mat2D {
    out[0] = a[0]
    out[1] = a[1]
    out[2] = a[2]
    out[3] = a[3]
    out[4] = a[4]
    out[5] = a[5]

    return out
}

// export function set(
//     out: Mat2D,
//     a: number,
//     b: number,
//     c: number,
//     d: number,
//     tx: number,
//     ty: number
// ): Mat2D {
//     out[0] = a
//     out[1] = b
//     out[2] = c
//     out[3] = d
//     out[4] = tx
//     out[5] = ty

//     return out
// }

// export function multiply(out: Mat2D, a: Mat2D, b: Mat2D): Mat2D {
//     const a0 = a[0],
//         a1 = a[1],
//         a2 = a[2],
//         a3 = a[3],
//         a4 = a[4],
//         a5 = a[5]
//     const b0 = b[0],
//         b1 = b[1],
//         b2 = b[2],
//         b3 = b[3],
//         b4 = b[4],
//         b5 = b[5]

//     out[0] = a0 * b0 + a2 * b1
//     out[1] = a1 * b0 + a3 * b1
//     out[2] = a0 * b2 + a2 * b3
//     out[3] = a1 * b2 + a3 * b3
//     out[4] = a0 * b4 + a2 * b5 + a4
//     out[5] = a1 * b4 + a3 * b5 + a5

//     return out
// }

export function translate(out: Mat2D, a: Mat2D, v: Vector): Mat2D {
    const a0 = a[0],
        a1 = a[1],
        a2 = a[2],
        a3 = a[3],
        a4 = a[4],
        a5 = a[5]
    const v0 = v[0],
        v1 = v[1]

    out[0] = a0
    out[1] = a1
    out[2] = a2
    out[3] = a3
    out[4] = a0 * v0 + a2 * v1 + a4
    out[5] = a1 * v0 + a3 * v1 + a5

    return out
}

export function scale(out: Mat2D, a: Mat2D, v: Vector): Mat2D {
    const a0 = a[0],
        a1 = a[1],
        a2 = a[2],
        a3 = a[3],
        a4 = a[4],
        a5 = a[5]
    const v0 = v[0],
        v1 = v[1]
    out[0] = a0 * v0
    out[1] = a1 * v0
    out[2] = a2 * v1
    out[3] = a3 * v1
    out[4] = a4
    out[5] = a5

    return out
}

// export function fromTranslation(out: Mat2D, v: Vector): Mat2D {
//     out[0] = 1
//     out[1] = 0
//     out[2] = 0
//     out[3] = 1
//     out[4] = v[0]
//     out[5] = v[1]

//     return out
// }

export function toCSSString(
    mat: Mat2D
): `matrix(${ScaleX}, 0, 0, ${ScaleY}, ${TranslateX}, ${TranslateY})` {
    return `matrix(${mat[0]}, 0, 0, ${mat[3]}, ${mat[4]}, ${mat[5]})`
}
